"use strict";

angular
    .module('rmApp')

    .directive('yTime', require('./y_time'))
    .directive('yCheckbox', require('./y_checkbox'))
    .directive('yMdCheckbox', require('./y_md_checkbox'))
    .directive('yText', require('./y_text'))
    .directive('yBlur', require('./y_blur'))
    .directive('yModelTypeSelect', require('./y_model_type_select'))
    .directive('yTags', require('./y_tags'))
;